import { render, staticRenderFns } from "./priceRequestList.vue?vue&type=template&id=251362c6&"
import script from "./priceRequestList.vue?vue&type=script&lang=js&"
export * from "./priceRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports